// extracted by mini-css-extract-plugin
export default {"box":"index_m_box__K3RbO"};